var XPortal = XPortal || {};

XPortal.PPUPG = (function () {
    var self = {
        prevCompanyNoResults: {},
        prevProjectByCustomerResults: {},
        ValidateCompanyNoUniqueness(data, modelName) {
            if (!data || !data.trim()) return true;
            if (!modelName || !modelName.length) return false;
            const model = XPortal.Store.GetModelByName(modelName);
            const uniqueId = model.entity.UniqueId;
            const pres = self.prevCompanyNoResults[modelName] || { res: false, prevNo: false };
            if (!pres.prevNo) self.prevCompanyNoResults[modelName] = pres;
            if (pres.prevNo == data) return pres.res;
            pres.prevNo = data;
            if (!data) return pres.res = true;
            const res = ensureCompanyExistsServerCall(pres, { uniqueId, data });
            return res;
        },
        ValidateResolutionForResolved(data, form, args) {
            if (!data) return true;
            var value = data.toLowerCase().trim();
            if (value != "resolved") return true;
            var settgs = XPortal.XPPS.GetHDTPageData(form, args);
            if (!settgs.isValid) return false;
            if (!settgs.resolution) return false;
            return true;
        },
        ValidateUploadToForResolved(data, form, args) {
            if (!data) return true;
            var value = data.toLowerCase().trim();
            if (value != "resolved") return true;
            var settgs = XPortal.XPPS.GetHDTPageData(form, args);
            if (!settgs.isValid) return false;
            if (!settgs.uploadto) return false;
            return true;
        },
        ValidateOnHoldReason(data, form, args) {
            if (!data) return true;
            var value = data.toLowerCase().trim();
            if (value != "on hold") return true;
            var sttgs = XPortal.XPPS.GetHDTPageData(form, args);
            if (!sttgs.isValid) return false;
            if (!sttgs.onholdreason) return false;
            return true;
        },
        ValidateClosureReason(data, form, args) {
            if (!data) return true;
            var value = data.toLowerCase().trim();
            if (value != "closed") return true;
            var sttgs = XPortal.XPPS.GetHDTPageData(form, args);
            if (!sttgs.isValid) return false;
            if (!sttgs.closurereason) return false;
            return true;
        },
        ValidateProjectByCustomer(data, modelName) {
            if (!data || !data.trim()) return true;
            if (!modelName || !modelName.length) return false;
            const model = XPortal.Store.GetModelByName(modelName);
            const customerNo = XPortal.Template.GetObjPropValueByName(model.entity, "customerno");
            const uniqueId = model.entity.UniqueId;
            const pres = self.prevProjectByCustomerResults[modelName] || { res: false, prevPrj: false, prevCust: false };
            if (!pres.prevPrj) self.prevProjectByCustomerResults[modelName] = pres;
            if (pres.prevPrj == data && pres.prevCust == customerNo) return pres.res;
            pres.prevPrj = data;
            pres.prevCust = customerNo;
            if (!data || !customerNo) return pres.res = true;
            const res = ensureProjectByCustomerServerCall(pres, { uniqueId, data, customerNo });
            return res;
        },
        LinkAction(grid, $btn, indRow, where) {
            const activerows = getSelectedObjects(grid, true, indRow);
            const gridInfo = XPortal.Grid.GetGridInfo(grid);
            const pinfo = gridInfo.kgrid.options.pageData.details.parentInfo;
            let item = Object.assign({}, gridInfo.kgrid.dataItem($([...indRow][0])), { pinfo });
            const opts = JSON.parse($btn.attr("data-href"));
            prepareAndClickLink(opts, Object.assign({ settings: { dialog: opts.dialog }, item, nodeId: gridInfo.nodeId, pinfo }));
        },
        LinkActionDetail(settings, item) {
            const opts = JSON.parse($(settings.button).attr("data-href"));
            prepareAndClickLink(opts, Object.assign({ settings: { dialog: opts.dialog }, item }), item);
        },
        HandleRedirected: function (expectedId) {
            if (!expectedId) return;

            var containerSelector = '#embed-detail-c' + expectedId;
            var $injectedForm = $(containerSelector + ' form.edit-form');
            if ($injectedForm.length === 0) return;

            var injectedSettingsStr = $injectedForm.attr('data-settings');
            if (!injectedSettingsStr) return;

            var injectedSettings = JSON.parse(injectedSettingsStr);
            var expectedNodeId = expectedId.toString();
            var actualNodeId = injectedSettings.NodeId ? injectedSettings.NodeId.toString() : '';
            if (expectedNodeId !== '' && actualNodeId !== '' && expectedNodeId !== actualNodeId) {
                setTimeout(function () {
                    $(containerSelector + ' .xdetailssection').removeClass('d-none opacity-0');
                }, 50);
            }
        },
    };
    function getSelectedObjects(grid, setCheck, rowstoprocess) {
        var griddata = grid.data("kendoGrid");
        var selectedrows = rowstoprocess ? rowstoprocess : XPortal.GridActions.GetActiveRows(grid, setCheck);
        var objects = [], ids = [];
        _.each(selectedrows, function (row) {
            var o = griddata.dataItem(row);
            if (o != undefined) {
                var id = o.UniqueId === null ? o.uniqueid : o.UniqueId;
                if (!ids.includes(id)) {
                    ids.push(id);
                    objects.push(o);
                }
            }
        });
        return objects;
    };
    function prepareAndClickLink(opts, sttgs, refreshData) {
        const linkHtml = XPortal.Format.GetLinkHtml(sttgs, opts);
        let $el = $(linkHtml).addClass("d-none action-link-a").attr("data-nodeid", sttgs.nodeId).attr("data-refresh-data", refreshData ? "1" : "0");
        $el.appendTo($("body"));
        $el[0].click();
        $el.remove();
    };
    function ensureCompanyExistsServerCall(contextObj, data) {
        $.ajax({
            url: "/umbraco/Surface/CustomCustomUI/EnsureCompanyExists",
            type: 'POST',
            dataType: 'json',
            async: false,
            contentType: 'application/json; charset=utf-8',
            cache: false,
            headers: { "RequestVerificationToken": XPortal.Main.getAntiForgeryToken() },
            data: JSON.stringify(data),
            success: function (d) {
                contextObj.res = !d.IsExists;
            },
            error: function () {
                contextObj.res = false;
            }
        });
        return contextObj.res;
    };
    function ensureProjectByCustomerServerCall(contextObj, data) {
        $.ajax({
            url: "/umbraco/Surface/CustomCustomUI/EnsureProjectByCustomer",
            type: 'POST',
            dataType: 'json',
            async: false,
            contentType: 'application/json; charset=utf-8',
            cache: false,
            headers: { "RequestVerificationToken": XPortal.Main.getAntiForgeryToken() },
            data: JSON.stringify(data),
            success: function (d) {
                contextObj.res = !d.IsValid;
            },
            error: function () {
                contextObj.res = false;
            }
        });
        return contextObj.res;
    };
    return self;
}());